module.exports = __webpack_public_path__ + "img/radiobox-marked.1215b735.svg";